/* KIAURA restock alerts: first-party Klaviyo Back In Stock, the one notify system for frames and tees.
   Markup comes from snippets/kiaura-restock.liquid. Every listener is delegated on document, so a
   colorway AJAX swap needs no re-init: the swapped section brings its own CTA and modal.

   Showing or hiding the CTA is not done here. It lives in the buy box's second slot and
   data-kia-buy-state on that row (server rendered, updated by variant-picker.js) decides it in CSS.

   Steps follow Klaviyo's "Back in Stock Multi-step" form:
     email  back in stock on EMAIL (+ email marketing on list TT5tif when the opt-in is ticked)
     sms    SMS marketing consent on list Sp9B2P, then back in stock on SMS
     done
   Every Klaviyo POST goes out with referrerPolicy no-referrer: Klaviyo's WAF 403s /client/*
   requests that carry a Referer (Sept 30 2026), which surfaces as "Failed to fetch". */
(function () {
  if (window.__kiauraRestock) return;
  window.__kiauraRestock = true;

  var KLAVIYO_COMPANY = 'Yg3gTU';
  var REVISION = '2026-10-15';
  var API = 'https://a.klaviyo.com/client/';
  var LIST_EMAIL_PROMO = 'TT5tif';  /* "Back in stock" list, the form's email submit */
  var LIST_SMS = 'Sp9B2P';          /* "SMS Subscriber" list, the form's SMS submit */
  var SOURCE = 'KIAURA Back in Stock (theme)';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* ---------- page side ---------- */

  function widgetFor(trigger) {
    var scope = trigger.closest('buy-buttons') || trigger.closest('.shopify-section') || document;
    return scope.querySelector('[data-kr]');
  }

  /* The selected variant is whatever the product form holds right now. Read at open for the
     header label and again at submit for the payload, so a size change or colorway swap is
     always honoured. */
  function selectedVariantId(widget) {
    if (!widget || !widget.isConnected) return null;
    var scope = widget.closest('buy-buttons') || widget.closest('.shopify-section') || document;
    var input = scope.querySelector('form.js-product-form [name="id"]');
    var id = input ? parseInt(input.value, 10) : NaN;
    return isNaN(id) ? null : id;
  }

  function variantLabel(widget, id) {
    if (!widget.__krVariants) {
      var tag = widget.querySelector('[data-kr-variants]');
      try { widget.__krVariants = JSON.parse(tag.textContent); } catch (e) { widget.__krVariants = []; }
    }
    for (var i = 0; i < widget.__krVariants.length; i++) {
      var v = widget.__krVariants[i];
      if (v.id === id && v.options) return v.options.join(' · ');
    }
    return widget.getAttribute('data-kr-color') || '';
  }

  /* The modal is moved to <body> on first open: transforms inside the product section would
     otherwise trap position:fixed. Once portaled it is no longer inside the widget, so it is
     resolved through this cache, never by querySelector on the widget. Modals left behind by a
     previous colorway are removed here. */
  function modalFor(widget) {
    if (widget.__krModal && document.body.contains(widget.__krModal)) return widget.__krModal;
    var modal = widget.querySelector('[data-kr-modal]');
    if (!modal) return null;
    document.querySelectorAll('body > [data-kr-modal]').forEach(function (m) {
      if (!m.__krWidget || !document.body.contains(m.__krWidget)) m.remove();
    });
    modal.__krWidget = widget;
    document.body.appendChild(modal);
    widget.__krModal = modal;
    return modal;
  }

  /* ---------- modal ---------- */

  function pane(modal, name) { return modal.querySelector('[data-kr-pane="' + name + '"]'); }

  function showError(modal, msg) {
    var el = pane(modal, modal.getAttribute('data-kr-step')).querySelector('[data-kr-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = !msg;
  }

  /* Step changes move focus to the step's first field, or to the step itself when it has none,
     so keyboard and screen reader users land in the new content. */
  function go(modal, step) {
    modal.setAttribute('data-kr-step', step);
    showError(modal, '');
    var p = pane(modal, step);
    var target = p.querySelector('input:not([type="checkbox"])') || p;
    target.focus({ preventScroll: true });
  }

  function open(trigger) {
    var widget = widgetFor(trigger);
    var modal = widget && modalFor(widget);
    if (!modal) return;
    modal.__krTrigger = trigger;
    modal.__krEmail = '';
    modal.removeAttribute('data-kr-email-done');
    /* Consent is given per signup: the opt-in starts unticked and the phone empty every time.
       The email is kept as typed, so a second size or colorway is quicker to sign up for. */
    modal.querySelector('[data-kr-promo]').checked = false;
    modal.querySelector('[data-kr-phone]').value = '';
    var label = modal.querySelector('[data-kr-variant-label]');
    if (label) label.textContent = variantLabel(widget, selectedVariantId(widget));
    modal.hidden = false;
    document.documentElement.classList.add('kr-lock');
    go(modal, 'email');
  }

  function close(modal) {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.classList.remove('kr-lock');
    var t = modal.__krTrigger;
    if (t && t.isConnected && t.offsetParent !== null) t.focus({ preventScroll: true });
  }

  /* ---------- Klaviyo ---------- */

  function post(path, body) {
    return fetch(API + path + '/?company_id=' + KLAVIYO_COMPANY, {
      method: 'POST',
      referrerPolicy: 'no-referrer',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error(path + ' HTTP ' + res.status);
      return res;
    });
  }

  function backInStock(variantId, channel, profile) {
    return post('back-in-stock-subscriptions', {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: [channel],
          profile: { data: { type: 'profile', attributes: profile } }
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
        }
      }
    });
  }

  /* Consent record + list membership. Only the channels named in `subscriptions` are subscribed,
     so passing the email alongside an SMS consent just ties the two to one profile. */
  function subscribe(listId, profile) {
    return post('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: SOURCE,
          profile: { data: { type: 'profile', attributes: profile } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    });
  }

  /* US and Canadian numbers only: the KIAURA SMS sender is a US toll-free number. */
  function toE164(raw) {
    var d = String(raw || '').replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    return /^[2-9]\d{2}[2-9]\d{6}$/.test(d) ? '+1' + d : null;
  }

  function busy(btn, on) {
    btn.disabled = on;
    if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
  }

  function submitEmail(modal, btn) {
    var input = modal.querySelector('[data-kr-email]');
    var email = (input.value || '').trim();
    if (!EMAIL_RE.test(email)) { showError(modal, 'Enter a valid email address.'); input.focus(); return; }
    var variantId = selectedVariantId(modal.__krWidget);
    if (!variantId) { showError(modal, 'Something went wrong. Refresh and try again.'); return; }
    showError(modal, '');
    busy(btn, true);

    var jobs = [backInStock(variantId, 'EMAIL', { email: email })];
    if (modal.querySelector('[data-kr-promo]').checked) {
      jobs.push(subscribe(LIST_EMAIL_PROMO, { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } }));
    }
    Promise.all(jobs)
      .then(function () {
        modal.__krEmail = email;
        modal.setAttribute('data-kr-email-done', '');
        go(modal, 'sms');
      })
      .catch(function () { showError(modal, 'Something went wrong. Please try again.'); })
      .then(function () { busy(btn, false); });
  }

  function submitSms(modal, btn) {
    var input = modal.querySelector('[data-kr-phone]');
    var phone = toE164(input.value);
    if (!phone) { showError(modal, 'Enter a valid US or Canadian mobile number.'); input.focus(); return; }
    var variantId = selectedVariantId(modal.__krWidget);
    if (!variantId) { showError(modal, 'Something went wrong. Refresh and try again.'); return; }
    showError(modal, '');
    busy(btn, true);

    var profile = { phone_number: phone };
    if (modal.__krEmail) profile.email = modal.__krEmail;
    /* Consent first, so the profile is SMS-subscribed by the time the back in stock flow
       looks for a channel to send on. */
    subscribe(LIST_SMS, Object.assign({ subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } }, profile))
      .then(function () { return backInStock(variantId, 'SMS', profile); })
      .then(function () { go(modal, 'done'); })
      .catch(function () { showError(modal, 'Something went wrong. Please try again.'); })
      .then(function () { busy(btn, false); });
  }

  /* ---------- events ---------- */

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-kr-open]');
    if (openBtn) { e.preventDefault(); open(openBtn); return; }
    var modal = e.target.closest('[data-kr-modal]');
    if (!modal) return;
    if (e.target.closest('[data-kr-close]')) { e.preventDefault(); close(modal); return; }
    if (e.target.closest('[data-kr-goto]')) { e.preventDefault(); go(modal, e.target.closest('[data-kr-goto]').getAttribute('data-kr-goto')); return; }
    /* "No thanks": the email signup already stands, so confirm it; with nothing submitted, just close. */
    if (e.target.closest('[data-kr-skip]')) { e.preventDefault(); if (modal.__krEmail) go(modal, 'done'); else close(modal); return; }
    var submitBtn = e.target.closest('[data-kr-submit]');
    if (submitBtn) {
      e.preventDefault();
      if (submitBtn.getAttribute('data-kr-submit') === 'sms') submitSms(modal, submitBtn);
      else submitEmail(modal, submitBtn);
    }
  });

  document.addEventListener('keydown', function (e) {
    var modal = document.querySelector('body > [data-kr-modal]:not([hidden])');
    if (!modal) return;
    if (e.key === 'Escape') { e.preventDefault(); close(modal); return; }
    if (e.key === 'Enter' && e.target.matches('[data-kr-email], [data-kr-phone]')) {
      e.preventDefault();
      modal.querySelector('[data-kr-pane="' + modal.getAttribute('data-kr-step') + '"] [data-kr-submit]').click();
      return;
    }
    /* Focus trap: Tab cycles within the visible step and the close button. */
    if (e.key === 'Tab') {
      var items = Array.prototype.filter.call(modal.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      var inside = modal.contains(document.activeElement);
      if (e.shiftKey && (document.activeElement === first || !inside)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !inside)) { e.preventDefault(); first.focus(); }
    }
  });
})();
